import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class StockTakeSessionReportLineQueryCriteriaClass extends BaseCriteriaModel {
  guid_session?: Optional<string> = Optional.empty();
  input_string?: Optional<string> = Optional.empty();
  guid_item?: Optional<string> = Optional.empty();
  item_code?: Optional<string> = Optional.empty();
  only_scanned?: Optional<boolean> = Optional.empty();
  inv_item_emp_status?: Optional<string> = Optional.empty();
  guids?: Optional<string> = Optional.empty();
}

export class StockTakeSessionReportLineCriteriaModelQuery {
  query = '';

  constructor(stockTakeSessionReportLineCriteriaModel: StockTakeSessionReportLineQueryCriteriaClass) {

    if (!stockTakeSessionReportLineCriteriaModel) {
      return;
    }

    this.query += stockTakeSessionReportLineCriteriaModel.guid_session.filter(x => x !== '').map(x => '&guid_session=' + x).orElse('');
    this.query += stockTakeSessionReportLineCriteriaModel.input_string.filter(x => x !== '').map(x => '&input_string=' + x).orElse('');
    this.query += stockTakeSessionReportLineCriteriaModel.guid_item.filter(x => x !== '').map(x => '&guid_item=' + x).orElse('');
    this.query += stockTakeSessionReportLineCriteriaModel.item_code.filter(x => x !== '').map(x => '&item_code=' + x).orElse('');
    this.query += stockTakeSessionReportLineCriteriaModel.only_scanned.filter(x => x !== null).map(x => '&only_scanned=' + x).orElse('');
    this.query += stockTakeSessionReportLineCriteriaModel.inv_item_emp_status.filter(x => x !== null).map(x => '&inv_item_emp_status=' + x).orElse('');
    this.query += stockTakeSessionReportLineCriteriaModel.guids.filter(x => x !== null).map(x => '&guids=' + x).orElse('');


    this.query += '&status=' + stockTakeSessionReportLineCriteriaModel.status;
    this.query += '&orderBy=' + stockTakeSessionReportLineCriteriaModel.orderBy;
    this.query += '&order=' + stockTakeSessionReportLineCriteriaModel.order;
    this.query += '&offset=' + stockTakeSessionReportLineCriteriaModel.offset + '&limit=' + stockTakeSessionReportLineCriteriaModel.limit;
    this.query += '&calcTotalRecords=' + stockTakeSessionReportLineCriteriaModel.calcTotalRecords;
  }
}
